module.exports = __webpack_public_path__ + "static/media/account.7b39ce93.svg";